import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import Banner from './Banner';
import PracticeAreasInfo from './PracticeAreasInfo';
class PracticeAreasApp extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

    if(window.location.hash) {
    setTimeout(function () {
      var hash = window.location.hash.substring(1);
      $('html, body').animate({scrollTop: $('#'+hash).offset().top-80
    }, 100);}, 1000);
  }else{
    $("html, body").animate({ scrollTop: 0 });
  }
  window.menu_selection('/practice');
}


  render() {
    return (
        <div className="container-xxl page_background p-0">
          <Spinner/>
          <TopMenu title="Practice Areas"/>
          <PracticeAreasInfo/>
          <Footer />
        </div>
    );
  }
}

export default PracticeAreasApp;
